import { createSlice } from "@reduxjs/toolkit";

const HeaderQty = createSlice({
  name: "HeaderQty",
  initialState: "",
  reducers: {
    saveHeaderQty: (state, action) => action.payload,
  },
});

export default HeaderQty;